import React from 'react';

import Button from './Button';
import projects from '../data/projects.json';
import "../css/Projects.css"

import WordSpeed from '../images/WordSpeed.png';
// import Friendash from '../images/Friendash.png';
import Spotelligence from '../images/Spotelligence.png';
import Jabooda from '../images/Jabooda.jpeg';

const imgNameToFile = {
  "WordSpeed.png": WordSpeed,
  "Friendash.png": null,
  "Spotelligence.png": Spotelligence,
  "Jabooda.jpeg": Jabooda
}

const Projects = () => (
  <div className="projects">
    <h1>PROJECTS</h1>
    {projects.map(project => (
      <div className='project-container'>
        <div className="project-detail project-info">
          <h2>{project.title}</h2>
          <h4>{project.tools.join(', ')}</h4>
          <p>{project.description}</p>
          <div className="button-container">
            {project.link && (
              <Button
                text="View Project"
                onClick={() => window.open(project.link, '_blank')}
              />
            )}
            <Button
              text="View on Github"
              onClick={() => window.open(project.github, '_blank')}
            />
            {project.githubBe && (
              <Button
                text="View Back end"
                onClick={() => window.open(project.link, '_blank')}
              />
            )}
          </div>
        </div>
        <div className="project-detail project-photo">
          <img width={500} src={imgNameToFile[project.img]} />
          {/* alt={project.img}  */}
        </div>
      </div>
    ))}
  </div>
);

export default Projects;
